import React from 'react';
import './styles.css';

const BrandLine = ({ classnames }) => <hr className={`brand-line ${classnames}`} />

export default BrandLine;
